import { vwoService } from "@trueskin-web/services"

import { apiVortex } from "./api"

const EVENT_TYPES_ENUM = {
  SET_USER_ID: "set-user-id",
  INITIAL_Q_PAGE_OPENED: "INITIAL_Q_PAGE_OPENED",
  INITIAL_Q_FORM_LOADED: "INITIAL_Q_FORM_LOADED",
  INITIAL_Q_QUESTION_OPENED: "INITIAL_Q_QUESTION_OPENED",
  INITIAL_Q_SUBMITTED: "INITIAL_Q_SUBMITTED",
  FINISH_INITIAL_QUESTIONNAIRE: "FINISH_INITIAL_QUESTIONNAIRE",
  SIGN_UP_OPENED: "SIGN_UP_OPENED",
  SIGN_UP_SUBMITTED: "SIGN_UP_SUBMITTED",
  ACCOUNT_CREATED: "ACCOUNT_CREATED",
  ACCOUNT_CREATION_ERROR: "ACCOUNT_CREATION_ERROR",
  LOGIN_POPUP_OPENED: "LOGIN_POPUP_OPENED",
  LOGIN_FROM_ERROR_MESSAGE: "LOGIN_FROM_ERROR_MESSAGE",
  PRODUCT_SELECTION_PAGE_OPENED: "PRODUCT_SELECTION_PAGE_OPENED",
  ADD_VOUCHER_ERROR: "ADD_VOUCHER_ERROR",
  VOUCHER_ADDED: "VOUCHER_ADDED",
  PRODUCT_CLICKED: "PRODUCT_CLICKED",
  PRODUCT_SELECTED: "PRODUCT_SELECTED",
  SHIPPING_PAGE_OPENED: "SHIPPING_PAGE_OPENED",
  SHIPPING_SUBMITTED: "SHIPPING_SUBMITTED",
  ADDRESS_SAVE_ERROR: "ADDRESS_SAVE_ERROR",
  SWISS_ERROR_2M: "SWISS_ERROR_2M",
  SWISS_ERROR_CLICK_ON_BACK: "SWISS_ERROR_CLICK_ON_BACK",
  SWISS_ERROR_CLICK_ON_CANCEL: "SWISS_ERROR_CLICK_ON_CANCEL",
  SHIPPING_ADDED: "SHIPPING_ADDED",
  NEW_TERMS_AND_CONDITIONS_VIEWED: "NEW_TERMS_AND_CONDITIONS_VIEWED",
  NEW_TERMS_AND_CONDITIONS_CLICK_ON_DISMISS:
    "NEW_TERMS_AND_CONDITIONS_CLICK_ON_DISMISS",
  CART_SUMMARY_PAGE: "CART_SUMMARY_PAGE",
  PAYMENT_METHOD_CLICKED: "PAYMENT_METHOD_CLICKED",
  NATIVE_PAYMENT_METHOD_CLICKED: "NATIVE_PAYMENT_METHOD_CLICKED",
  PAYMENT_METHOD_OPENED: "PAYMENT_METHOD_OPENED",
  PAYMENT_METHOD_ADDED: "PAYMENT_METHOD_ADDED",
  NATIVE_PAYMENT_METHOD_ADDED: "NATIVE_PAYMENT_METHOD_ADDED",
  PAYMENT_METHOD_UPDATED: "PAYMENT_METHOD_UPDATED",
  PAYMENT_INITIATED: "PAYMENT_INITIATED",
  PAYMENT_SUCCEEDED: "PAYMENT_SUCCEEDED",
  PAYMENT_ERROR: "PAYMENT_ERROR",
  ADD_NATIVE_PAYMENT_METHOD_ERROR: "ADD_NATIVE_PAYMENT_METHOD_ERROR",
  CHANGE_PLAN: "CHANGE_PLAN",
  DATA_CHECK_Q_PAGE_OPENED: "DATA_CHECK_Q_PAGE_OPENED",
  DATA_CHECK_Q_FORM_LOADED: "DATA_CHECK_Q_FORM_LOADED",
  DATA_CHECK_Q_QUESTION_OPENED: "DATA_CHECK_Q_QUESTION_OPENED",
  DATA_CHECK_Q_SUBMITTED: "DATA_CHECK_Q_SUBMITTED",
  UPLOAD_IMAGES_PAGE_OPENED: "UPLOAD_IMAGES_PAGE_OPENED",
  UPLOAD_IMAGES_SELECTED: "UPLOAD_IMAGES_SELECTED",
  UPLOAD_IMAGES_SUBMITTED: "UPLOAD_IMAGES_SUBMITTED",
  UPLOAD_IMAGES_SUCCEEDED: "UPLOAD_IMAGES_SUCCEEDED",
  UPLOAD_IMAGES_SKIP_BUTTON_CLICKED: "UPLOAD_IMAGES_SKIP_BUTTON_CLICKED",
  WAITING_AREA_OPENED: "WAITING_AREA_OPENED",
  SELECT_PAYMENT_OPTION: "SELECT_PAYMENT_OPTION",
  RETURNING_USER_EVENT: "ReturningUser",
  REVIEW_INITIAL_QUESTIONNAIRE_CLICKED: "ReviewInitialQuestionnaireClicked",
  RETAKE_INITIAL_QUESTIONNAIRE_CLICKED: "RetakeInitialQuestionnaireClicked",
  RETAKE_INITIAL_QUESTIONNAIRE_SUBMITTED: "RetakeInitialQuestionnaireSubmitted",
  WELCOME_BACK_PAGE_OPENED: "WelcomeBackPageOpened",
  WELCOME_BACK_PAGE_PAYMENT_CTA_CLICKED: "WelcomeBackPagePaymentCtaClicked",
  WELCOME_BACK_PAGE_PLAN_SELECTION_CTA_CLICKED:
    "WelcomeBackPagePlanSelectionCtaClicked",
  FIRST_SHIPPING_PAGE_FILLED: "FirstShippingPageFilled",
  NAVIGATION_PAGE_PLAN_SELECTION_CTA_CLICKED:
    "NavigationPagePlanSelectionCtaClicked",
}

const CONSENT_TOOL_KLARO = "klaro"

const getConsentTool = () =>
  typeof window === "undefined"
    ? null
    : window.klaro
    ? CONSENT_TOOL_KLARO
    : null

const getConsentFromKlaro = (consentServiceName) =>
  window.klaro.getManager().getConsent(consentServiceName.toLowerCase())

const getConsent = (consentServiceName) => {
  switch (getConsentTool()) {
    case CONSENT_TOOL_KLARO:
      return getConsentFromKlaro(consentServiceName)
    default:
      return false
  }
}

const consentSettings = () => {
  switch (getConsentTool()) {
    case CONSENT_TOOL_KLARO:
      return window.klaro.show(undefined, true)
  }
}

const trackEvent = (event) => {
  if (event.isGeneric) {
    return trackGenericEvent(event)
  }
  try {
    if (!window.dataLayer) {
      window.dataLayer = []
    }

    window.dataLayer.push({
      data: {
        ...event,
        custom_data: {
          ...event.custom_data,
          ...vwoService.getVwoExperimentsEventData(),
        },
      },
      event: event.name,
    })
  } catch {
    // no-op
  }
}

// TODO Remove it along with the backend event correction
const trackGenericEvent = (event) => {
  try {
    if (!window.dataLayer) {
      window.dataLayer = []
    }

    window.dataLayer.push(event)
  } catch {
    // no-op
  }
}

const sendEvent = async (event) => {
  const { name, data } = event
  const marketingEventData = {
    ...vwoService.getVwoExperimentsEventData(),
    ...data,
  }

  return apiVortex()
    .postMarketingEvent({
      name,
      data: marketingEventData,
    })
    .catch(() => {
      // no-op
    })
}

export {
  EVENT_TYPES_ENUM,
  getConsent,
  getConsentTool,
  consentSettings,
  trackEvent,
  trackGenericEvent,
  sendEvent,
}
